import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';
import { usePropertyInfoQuery } from '../../../utils/queries';
import { EXTERNAL_WIZARD_OPTIONS, WIZARD_SCREEN_TYPES } from '../../../constants/stringConstants';
import { useLeasingUrlParams } from '../../../hooks/useLeasingUrlParams';

export default function AreYouPlanningToSell({ onRadioSelect }: { onRadioSelect }) {
  const { propertyId } = useLeasingUrlParams();
  const propertyInfoQuery = usePropertyInfoQuery(propertyId, !!propertyId);

  return (
    <FieldSet
      required
      legend={
        <Legend>
          {!propertyInfoQuery?.data?.streetAddress
            ? `Are you planning to sell?`
            : `Are you planning to sell ${propertyInfoQuery?.data?.streetAddress}?`}
        </Legend>
      }
    >
      <LabeledControl
        label={<Label>Yes</Label>}
        control={
          <Radio
            name="are-you-planning-to-sell"
            onChange={onRadioSelect}
            value={EXTERNAL_WIZARD_OPTIONS.SEND_TO_SELLING}
          />
        }
      />
      <LabeledControl
        label={<Label>No</Label>}
        control={
          <Radio name="are-you-planning-to-sell" onChange={onRadioSelect} value={WIZARD_SCREEN_TYPES.YOURE_ALL_SET} />
        }
      />
    </FieldSet>
  );
}
